module.exports = __webpack_public_path__ + "static/media/apng_porin.9cc38a01.png";